const divFormService = {
  inspectedBy: 'Inspecionado por:',
  itemLabel: 'Local',
  equipment: 'Equipamento',
  serialNumber: 'S/N:',
  reference: 'Ponto de Referência: ',
  description: 'Descrição do Equipamento:',
  fileStillUploading: 'Aguarde todos os arquivos subirem',
  fileError: 'Existem arquivos submetidos com erro',
  equipmentModelDescription: 'Descrição do Tipo de Equipamento: '
};

export default divFormService;
